/**
 * Entity Navigation Utility
 *
 * Resolves entity names to URL paths using the generated navigation config.
 * Used by TaskActionView and TaskInboxPage to build "View Entity" links.
 */

import { moduleNavigation } from '@/config/navigation.generated';

/**
 * Resolve the URL for viewing a specific entity instance.
 * Searches all modules' navigation items for a matching entity name.
 *
 * @param entityName Clean entity name (e.g., "Order", "Product")
 * @param entityId Entity ID (UUID)
 * @returns URL path (e.g., "/sales/orders/abc-123") or null if not found
 */
export function resolveEntityUrl(entityName: string | undefined, entityId: string): string | null {
  if (!entityName || !entityId) return null;

  // Search all modules for a navigation item matching this entity name
  for (const module of moduleNavigation) {
    for (const category of module.categories) {
      for (const item of category.items) {
        if (item.entity === entityName) {
          return `${item.path}/${entityId}`;
        }
      }
    }
  }

  return null;
}
